import { FC } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { observer } from 'mobx-react';
import { useGdms } from '@/store';
import LocaleSelect from '@/components/LocaleSelect';
import './index.less';

const Layout: FC = (props) => {
  const { pathname } = useLocation();
  const { isFromGdms } = useGdms();
  return (
    <div className='layout-page'>
      <div className='layout-header'>
        {isFromGdms ? (
          <span className='header-logo' />
        ) : (
          <Link className='header-logo' to='/' />
        )}

        <div>{pathname.match(/\/([^/]+)\//)?.[1]?.toUpperCase()}</div>
        <LocaleSelect />
      </div>
      <div className='layout-content'>{props.children}</div>
    </div>
  );
};

export default observer(Layout);
